import {
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_BEGIN,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_SUCCESS,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_FAILURE,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadExternalDatabaseForDirectus(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_BEGIN,
    });
    const { projectId, version, externalDbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/directus/${externalDbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_SUCCESS,
            data: res.data,
          });
          console.log('233333', res.data);
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalDatabaseForDirectusError() {
  return {
    type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_BEGIN:
      return {
        ...state,
        loadExternalDatabaseForDirectusPending: true,
        loadExternalDatabaseForDirectusError: null,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_SUCCESS:
      return {
        ...state,
        loadExternalDatabaseForDirectusPending: false,
        loadExternalDatabaseForDirectusError: null,
        externalDbDirectus: action.data,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_FAILURE:
      return {
        ...state,
        loadExternalDatabaseForDirectusPending: false,
        loadExternalDatabaseForDirectusError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_DISMISS_ERROR:
      return {
        ...state,
        loadExternalDatabaseForDirectusError: null,
      };

    default:
      return state;
  }
}
